import { useTranslation } from "react-i18next";

import { useJobLocationParts } from "@av/apps/recruitment/ats-common/services/job-posts/hooks/useJobLocationParts";
import {
  resolveEmploymentTypeTranslation,
  resolveLocationTypeTranslation,
} from "@av/apps/recruitment/ats-common/services/job-posts/job-posts";
import type { EmploymentType, LocationType } from "@av/apps/recruitment/ats-common/types";

export function JobLocationArrangment({
  locationType,
  city,
  subdivisionCode,
  employmentType,
}: {
  locationType?: LocationType;
  city?: string;
  subdivisionCode?: string;
  employmentType?: EmploymentType;
}) {
  const { t } = useTranslation();
  const fallback = t("recruitment.jobs.notSpecified");

  const location = locationType ? resolveLocationTypeTranslation(t, locationType) : undefined;
  const employment = employmentType
    ? resolveEmploymentTypeTranslation(t, employmentType)
    : undefined;
  const {
    fullText: locationDetail,
    cityPart,
    provincePart,
  } = useJobLocationParts(city, subdivisionCode, {
    provinceFormat: "short",
  });

  if (locationType === "REMOTE") {
    return locationDetail
      ? `${location || fallback} (${locationDetail}) | ${employment || fallback}`
      : `${location || fallback} | ${employment || fallback}`;
  }

  return `${location || fallback} (${cityPart || fallback}, ${provincePart || fallback}) | ${employment || fallback}`;
}
